import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortBarComponent } from './sort-bar.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [SortBarComponent],
  imports: [
    CommonModule,
    DirectivesModule,
    NgbDropdownModule,
    InlineSVGModule,
    FGBSharedModule
  ],
  exports: [SortBarComponent],
})
export class SortBarModule {}
